import type { RechercheDemandeQueryDTO, RechercheResultDTO } from '@/features/api/extranet/dto/Demande/Recherche'
import { buildRechercheStore } from '../storeRechercheBuilder'

export const useRechercheDemandeStore = buildRechercheStore<RechercheDemandeQueryDTO, RechercheResultDTO>({
  storeName: 'rechercheDemandeStore',
  apiPath: `/formation/demandes`,
})
